// extracted by mini-css-extract-plugin
module.exports = {"head":"page-head_head__8hFNJ","left":"page-head_left__0XU7s","right":"page-head_right__N8uLD"};